import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileAvatarComponent } from './profile-avatar.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { ImageCropperModule } from 'ngx-image-cropper';



@NgModule({
  declarations: [ProfileAvatarComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule,
    ImageCropperModule
  ]
})
export class ProfileAvatarModule { }
